import React from "react";
import FormHelperText from "components/Form/components/FormHelperText";
import FormSubtext from "./FormSubtext";

const CheckboxGroup = ({
  id,
  classes,
  error,
  label,
  name,
  placeholder,
  register,
  options,
  ...inputProps
}) => {
  const groupKey = id ?? name;

  const getCheckboxId = (option) => {
    const optionId = option.value.toLowerCase().replaceAll(" ", "-");

    return `${groupKey}_${optionId}`;
  };

  const checkboxElements = options.map((option) =>
    (
      <div key={getCheckboxId(option)}>
        <label htmlFor={getCheckboxId(option)}>
          <input
            type="checkbox"
            {...(option.checked ? "checked" : "")}
            {...register(name)}
            value={option.value}
            className={`input-checkbox ${classes ?? ""}`}
            id={getCheckboxId(option)}
            aria-label={label}
          />
          <span className="ml-2">
            {option.label}
          </span>
        </label>
        {error && <FormHelperText message={error.message} />}
      </div>
    ));

  return (
    <div className="input__checkbox-group" key={groupKey}>
      <label key={`${groupKey}__label`}>
        {label}
      </label>
      {inputProps.subtext && <FormSubtext text={inputProps.subtext} />}

      <div className="input__checkbox-group__options" key={`${groupKey}__options`}>
        {checkboxElements}
      </div>
    </div>
  );
};

export default CheckboxGroup;
